import { makeAutoObservable } from 'mobx';

import { ApiRoutes } from '../../config/ApiRoutes';
import { RootStore } from '../index';

export class EquipmentInspectionApiStore {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  addEquipmentInspection = (data: any) => {
    const {
      Add: { Endpoint, Method },
    } = ApiRoutes.EquipmentInspection;
    return this.rootStore.apiStore.call<any>({
      data,
      method: Method,
      url: Endpoint,
    });
  };
}
